import { EMAIL_STATUS } from '../email/index';
import type { EmittedEmail } from '../email/index';
import { baseDocumentFactory } from './base-document.factory';
import { ObjectFactory } from './object.factory';

export class EmittedEmailFactory extends ObjectFactory<EmittedEmail> {
  protected getDefaults(): EmittedEmail {
    return {
      ...baseDocumentFactory.build(),
      events: [],
      identifiers: { tenantId: 'tenant-test' },
      responseTopic: '',
      sgMessageId: '',
      status: EMAIL_STATUS.PENDING,
      templateData: { name: 'John' },
      templateName: 'welcome-email',
      to: 'john@example.com',
    };
  }
}

export const emittedEmailFactory = new EmittedEmailFactory();
